const ENV = process.env.VUE_APP_ENV;
const advertCode = [
  {
    code: '10',
    year: 25,
    homePopupCode: 'App25001',
    bannerCode: 'App25002',
    customButtonCode: 'App25003',
    bigAdvertCode: 'App25004',
    smallAdvertCode: 'App25005',
    openLiveCode: 'App25006',
    hotSaleCourseId: ENV === 'test' || ENV === 'local' ? 296 : 271,
    postgraduateChatCode: 'App25007',
    limtiCouponCode: 'App25008',
    bottomFloatCode: 'App25009',
  },
  {
    code: '12',
    year: 26,
    homePopupCode: 'App26001',
    bannerCode: 'App26002',
    customButtonCode: 'App26003',
    bigAdvertCode: 'App26004',
    smallAdvertCode: 'App26005',
    openLiveCode: 'App26006',
    hotSaleCourseId: ENV === 'test' || ENV === 'local' ? 296 : 271,
    postgraduateChatCode: 'App26007',
    limtiCouponCode: 'App26008',
    bottomFloatCode: 'App26009',
  },
];
export { advertCode };